<template>
  <div class="py-3 px-5 border-t border-bordergray bg-white">
    <myc-footer-text :text="copyright" />
  </div>
</template>

<script>
import MycFooterText from '@/components/common/myc-footer-text.vue';

export default {
  name: 'MycFooter',
  components: {
    MycFooterText,
  },
  data() {
    return {
      copyright: `© ${new Date().getFullYear()} Countly Ltd.`,
    };
  },
};
</script>
